import { render, staticRenderFns } from "./CbsObjectView.vue?vue&type=template&id=0d73805c&scoped=true"
import script from "./CbsObjectView.vue?vue&type=script&lang=js"
export * from "./CbsObjectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d73805c",
  null
  
)

export default component.exports